module.exports = __webpack_public_path__ + "static/media/bayBridge.eefba0ac.jpg";